import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, SupplierBillData } from './types'

export const selectSupplierBillListEvent = (state: RootState): Event => state.supplierBillReducer.listEvent

export const selectSupplierBillList = (state: RootState): ListData => state.supplierBillReducer.list

export const selectSupplierBillActionEvent = (state: RootState): Event =>
  state.supplierBillReducer.actionEvent

export const selectSupplierBillDetail = (state: RootState): SupplierBillData | undefined =>
  state.supplierBillReducer.detail

export const selectSupplierBillDetailEvent = (state: RootState): Event =>
  state.supplierBillReducer.detailEvent
